namespace Sapphire {

    export class linePoint extends PIXI.Point {

        private targetX: number;
        private targetY: number;

        public topY;
        public bottomY;

        public mTop: number;
        public bTop: number;
        public mBottom: number;
        public bBottom: number;

        private minX;

        private rangeX: number;

        private isFixedX: boolean;
        private isRestrictedY: boolean;

        constructor(x: number, y: number, minX: number = null, maxX: number = null, isRestrictedY: boolean = false) {
            super(x, y);
            this.targetX = x;
            this.targetY = y;

            this.minX = minX;

            this.rangeX = maxX - minX;

            this.isFixedX = this.minX == maxX || this.minX == null;
            this.isRestrictedY = isRestrictedY;

            this.x = x;
            this.y = y;
        }

        public createClone(): linePoint {
            var newPoint = new linePoint(this.targetX,this.targetY,this.minX,this.rangeX+this.minX,this.isRestrictedY);

            newPoint.topY = this.topY;
            newPoint.bottomY = this.bottomY;
            
            newPoint.mTop = this.mTop;
            newPoint.bTop = this.bTop;
            newPoint.mBottom = this.mBottom;
            newPoint.bBottom = this.bBottom;

            return newPoint;
        }

        public nextPosition(): void {
            if (!this.isFixedX) {
                this.x = this.minX + Math.round(Math.random() * this.rangeX);
            }

            if (!this.isRestrictedY) {
                var minY = (this.mTop * this.x) + this.bTop;
                var maxY = (this.mBottom * this.x) + this.bBottom;
                this.y = minY + Math.round(Math.random() * (maxY - minY));
            } else {
                var minY = this.targetY - 20;
                var maxY = this.targetY + 20;
                this.y = minY + Math.round(Math.random() * (maxY - minY));
            }
        }
    }

    export class LightningSettings extends Object {
        /* number of steps between reels */
        public segments: number = 6;
        /* how much of the width to show at any time, between 0 and 1 */
        public maskSpread: number = 0.8;
        /* how large the vertical should be */
        public ySpread: number = 100;

        /* how long in seconds it should take for the animation to run */
        public duration: number = 1.5;
    };

    export class Lightning extends PIXI.Graphics {

        private _bigLines: linePoint[][];
        private _smallLines: linePoint[][];

        private _cellHeightRadius: number;
        
        private _timeLine: TweenMax;

        private _maskSprite: PIXI.Graphics | PIXI.Sprite;

        private _minX: number;
        private _maxX: number;
        private _maskWidth: number;

        private _settings: LightningSettings;
        private _asset: PIXI.Sprite;
        private _asset2: PIXI.Sprite;

        private _isWebGL: boolean;

        constructor(asset: PIXI.Sprite, asset2: PIXI.Sprite, isWebGL: boolean) {
            super();

            this._asset = asset;
            this._asset2 = asset2;

            this._isWebGL = isWebGL;
        }

        private makePoint(xCoord: number, yCoord: number, lastPoint: linePoint = null): linePoint {
            var pt = new linePoint(xCoord, yCoord, null, null, true);
            pt.topY = yCoord - this._cellHeightRadius;
            pt.bottomY = yCoord + this._cellHeightRadius;
            if (lastPoint != null) {
                pt.mTop = (pt.topY - lastPoint.topY) / (xCoord - lastPoint.x);
                pt.mBottom = (pt.bottomY - lastPoint.bottomY) / (xCoord - lastPoint.x);
                pt.bTop = pt.topY - (pt.mTop * xCoord);
                pt.bBottom = pt.bottomY - (pt.mBottom * xCoord);
            }

            return pt;
        }

        private createLinearGradient(width, height, stops): PIXI.Texture {

            var canvas = document.createElement('canvas');

            canvas.width = width;
            canvas.height = height;

            var ctx = canvas.getContext('2d');
            var gradient = ctx.createLinearGradient(0, 0, width, 0);
            var stopPoints = Object.keys(stops);

            for (var i = 0, n = stopPoints.length; i < n; i += 1) {
                gradient.addColorStop(parseFloat(stopPoints[i]), stops[stopPoints[i]]);
            }

            ctx.fillStyle = gradient;
            ctx.fillRect(0, 0, width, height);

            return PIXI.Texture.fromCanvas(canvas);
        };

        public generate(coords: any, options: Object = {}): void {

            var defaults: LightningSettings = new LightningSettings();

            if (options != null) {
                this._settings = LightningSettings.assign(defaults, options);
            } else {
                this._settings = defaults;
            }

            this._cellHeightRadius = this._settings.ySpread / 1.5;

            this._minX = coords[0][0] - 50;
            this._maxX = coords[coords.length - 1][0] + 50;
            this._maskWidth = (this._maxX - this._minX) * this._settings.maskSpread;

            var linesToDraw = 2;
            
            var coordIdx: number, lineIdx: number, blockIdx: number;
            for (coordIdx = 0; coordIdx < coords.length; ++coordIdx) {
                if (coords[coordIdx][1].length == 3) {
                    linesToDraw = 6;
                    break;
                } else if (coords[coordIdx][1].length == 2) {
                    linesToDraw = 4;
                }
            }

            var lines: linePoint[][] = [];
            for (lineIdx = 0; lineIdx < linesToDraw; ++lineIdx) {
                lines[lineIdx] = [];
            }

            var blockUse: number[][][] = [];

            var maskMinY = 1000000;
            var maskMaxY = 0;

            for (coordIdx = 0; coordIdx < coords.length; ++coordIdx) {
                var blockIndex: number = 0;
                blockUse[coordIdx] = [];
                for (blockIdx = 0; blockIdx < coords[coordIdx][1].length; ++blockIdx) {
                    blockUse[coordIdx][blockIdx] = [];
                }
                if (coordIdx == 0) {
                    for (lineIdx = 0; lineIdx < linesToDraw; ++lineIdx) {
                        //for the y coord, we want between the 2 boundaries;
                        if (coords[coordIdx][1][blockIndex] < maskMinY) {
                            maskMinY = coords[coordIdx][1][blockIndex];
                        }
                        if (coords[coordIdx][1][blockIndex] > maskMaxY) {
                            maskMaxY = coords[coordIdx][1][blockIndex];
                        }
                        blockUse[coordIdx][blockIndex].push(lineIdx);
                        var pt = this.makePoint(coords[coordIdx][0], coords[coordIdx][1][blockIndex], null);
                        lines[lineIdx].push(pt);
                        blockIndex++;
                        if (blockIndex >= coords[coordIdx][1].length) {
                            blockIndex = 0;
                        }
                    }
                } else {
                    //cycle throug the previous block indexes, and use them
                    var previousBlock: number[][] = blockUse[coordIdx - 1];
                    for (blockIdx = 0; blockIdx < previousBlock.length; blockIdx++) {
                        for (var prevBlockIdx = 0; prevBlockIdx < previousBlock[blockIdx].length; prevBlockIdx++) {
                            var lineIndex: number = previousBlock[blockIdx][prevBlockIdx];
                            blockUse[coordIdx][blockIndex].push(lineIndex);
                            var pt = this.makePoint(coords[coordIdx][0], coords[coordIdx][1][blockIndex], lines[lineIndex][coordIdx - 1]);
                            lines[lineIndex].push(pt);

                            if (coordIdx == 1) {
                                lines[lineIndex][0].mTop = pt.mTop;
                                lines[lineIndex][0].mBottom = pt.mBottom;
                                lines[lineIndex][0].bTop = pt.bTop;
                                lines[lineIndex][0].bBottom = pt.bBottom;
                            }
                            if (coords[coordIdx][1][blockIndex] < maskMinY) {
                                maskMinY = coords[coordIdx][1][blockIndex];
                            }
                            if (coords[coordIdx][1][blockIndex] > maskMaxY) {
                                maskMaxY = coords[coordIdx][1][blockIndex];
                            }
                            blockIndex++;
                            if (blockIndex >= coords[coordIdx][1].length) {
                                blockIndex = 0;
                            }
                        }
                    }
                }
            }

            //these will be used for creating the mask
            maskMinY -= this._settings.ySpread * 2;
            maskMaxY += this._settings.ySpread * 2;

            this._bigLines = [];
            for (lineIdx = 0; lineIdx < linesToDraw; ++lineIdx) {

                //build the global lines
                this._bigLines[lineIdx] = [];
                this._bigLines[lineIdx].push(lines[lineIdx][0].createClone());
                for (var pointIdx = 1; pointIdx < lines[lineIdx].length; ++pointIdx) {

                    //create the bits in between
                    var segmentLengthX: number = (lines[lineIdx][pointIdx].x - lines[lineIdx][pointIdx - 1].x) / this._settings.segments;
                    var segmentLengthY: number = (lines[lineIdx][pointIdx].y - lines[lineIdx][pointIdx - 1].y) / this._settings.segments;

                    var segSizeX = segmentLengthX / 2;
                    var xFrom = lines[lineIdx][pointIdx - 1].x;
                    var yFrom = lines[lineIdx][pointIdx - 1].y;
                    for (var segmentIdx = 1; segmentIdx < this._settings.segments - 1; ++segmentIdx) {
                        var nextX = xFrom + (segmentLengthX * segmentIdx);
                        var nextY = yFrom + (segmentLengthY * segmentIdx);

                        var pt = new linePoint(nextX, nextY, nextX - segSizeX, nextX + segSizeX);

                        pt.mTop = lines[lineIdx][pointIdx].mTop;
                        pt.mBottom = lines[lineIdx][pointIdx].mBottom;
                        pt.bTop = lines[lineIdx][pointIdx].bTop;
                        pt.bBottom = lines[lineIdx][pointIdx].bBottom;

                        this._bigLines[lineIdx].push(pt);
                    }

                    //and now add the point itself
                    this._bigLines[lineIdx].push(lines[lineIdx][pointIdx].createClone());
                }
            }
            this._smallLines = [];
            for (lineIdx = 0; lineIdx < linesToDraw*2; ++lineIdx) {

                var baseLineIdx = Math.floor(lineIdx/2);
                //build the global lines
                this._smallLines[lineIdx] = [];
                this._smallLines[lineIdx].push(lines[baseLineIdx][0].createClone());
                for (var pointIdx = 1; pointIdx < lines[baseLineIdx].length; ++pointIdx) {

                    //create the bits in between
                    var segmentLengthX: number = (lines[baseLineIdx][pointIdx].x - lines[baseLineIdx][pointIdx - 1].x) / this._settings.segments;
                    var segmentLengthY: number = (lines[baseLineIdx][pointIdx].y - lines[baseLineIdx][pointIdx - 1].y) / this._settings.segments;

                    var segSizeX = segmentLengthX;
                    var xFrom = lines[baseLineIdx][pointIdx - 1].x;
                    var yFrom = lines[baseLineIdx][pointIdx - 1].y;
                    for (var segmentIdx = 1; segmentIdx < this._settings.segments - 1; ++segmentIdx) {
                        var nextX = xFrom + (segmentLengthX * segmentIdx);
                        var nextY = yFrom + (segmentLengthY * segmentIdx);

                        var pt = new linePoint(nextX, nextY, nextX - segSizeX, nextX + segSizeX);

                        pt.mTop = lines[baseLineIdx][pointIdx].mTop;
                        pt.mBottom = lines[baseLineIdx][pointIdx].mBottom;
                        pt.bTop = lines[baseLineIdx][pointIdx].bTop;
                        pt.bBottom = lines[baseLineIdx][pointIdx].bBottom;

                        this._smallLines[lineIdx].push(pt);
                    }

                    //and now add the point itself
                    this._smallLines[lineIdx].push(lines[baseLineIdx][pointIdx].createClone());
                }
            }

            if(this._isWebGL){
                this._maskSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
                var gradientTexture: PIXI.Texture = this.createLinearGradient(1000, 800, {
                    0: 'black',
                    0.3: 'white',
                    0.7: 'white',
                    1: 'black',
                });

                this._maskSprite.texture = gradientTexture;

                this._maskSprite.width = this._maskWidth;
                this._maskSprite.height = maskMaxY - maskMinY;
            }else{
                this._maskSprite = new PIXI.Graphics();
                this._maskSprite.beginFill(0xFFFFFF,1);
                this._maskSprite.drawRect(0,0,this._maskWidth, maskMaxY-maskMinY);
                this._maskSprite.endFill();
            }


            this._maskSprite.x = this._minX - this._maskSprite.width;
            this._maskSprite.y = maskMinY;

            this.mask = this._maskSprite;
            this.addChild(this._maskSprite);

            //redeclare lineIdx here to keep the scope local and hopefully help garbage collection. Probably not needed once Kev has re-worked this bit.
            for (var lineIdx: number = 0; lineIdx < this._bigLines.length; ++lineIdx) {
                var Rope = new PIXI.mesh.Rope(this._asset.texture, this._bigLines[lineIdx])
                this.addChild(Rope);
            }

            for (var lineIdx: number = 0; lineIdx < this._smallLines.length; ++lineIdx) {
                var Rope = new PIXI.mesh.Rope(this._asset2.texture, this._smallLines[lineIdx])
                this.addChild(Rope);
            }
        }

        get maskSprite(): PIXI.Sprite | PIXI.Graphics {
            return this._maskSprite;
        }

        public play(callback?: any): void {

            if(typeof callback != "function"){
                callback = () => {};
            }
            //this.updateTheLines();
            /*if (this._timeLine == undefined || this._timeLine == null) {
                var tthis = this;
                this._timeLine = new TimelineMax({repeat: -1, useFrames: true}).call(function () {
                }, null, this, 5);
            }
            this._timeLine.play();*/

            this._maskSprite.x = this._minX - this._maskSprite.width;

            for (var lineIdx: number = 0; lineIdx < this._bigLines.length; ++lineIdx) {
                for (var pointIdx: number = 0; pointIdx < this._bigLines[lineIdx].length; ++pointIdx) {
                    this._bigLines[lineIdx][pointIdx].nextPosition();
                }
            }
            for (var lineIdx: number = 0; lineIdx < this._smallLines.length; ++lineIdx) {
                for (var pointIdx: number = 0; pointIdx < this._smallLines[lineIdx].length; ++pointIdx) {
                    this._smallLines[lineIdx][pointIdx].nextPosition();
                }
            }

            this._timeLine = TweenMax.to(this._maskSprite,this._settings.duration, {
                x: this._maxX,
                onComplete: callback
            });
        }

        public pause(): void {
            this._timeLine.pause();
        }

        public stop(): void {
            if (this._timeLine) {
                this._timeLine.kill();
                this._timeLine = null;
            }
        }

        public reset(): void {
            this.stop();
            for(var i=0; i < this._bigLines.length; ++i){
                this._bigLines[i] = null;
              }
              for(var i=0; i < this._smallLines.length; ++i){
                this._smallLines[i] = null;
              }
            this._bigLines = [];
            this._smallLines = [];
            this._cellHeightRadius = 0;
            if (this.maskSprite) this.maskSprite.destroy(true);

            //remove all the ropes too
            while (this.children[0]) {
                var child: PIXI.Graphics | PIXI.Sprite | PIXI.mesh.Rope = <PIXI.Graphics | PIXI.Sprite | PIXI.mesh.Rope>this.children[0]; 
                child.destroy(true);
                this.removeChild(this.children[0])
            }
        }
    }
}
